import { render, staticRenderFns } from "./finStrategy.vue?vue&type=template&id=baf598f8&scoped=true&"
import script from "./finStrategy.vue?vue&type=script&lang=js&"
export * from "./finStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf598f8",
  null
  
)

export default component.exports